import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addAddressProvider } from '../data-provider';
import { CACHE_KEYS } from '../types';

export const useAddAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // TODO: fix types
    // @ts-expect-error
    mutationFn: addAddressProvider,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...CACHE_KEYS.all, 'addressBookSearch'],
      });
    },
  });
};
